import Scrollbars from "react-custom-scrollbars";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import personIcon from "../../../../../media/images/icons/assets_light/outline-management-person-active.svg";
import personsIcon from "../../../../../media/images/icons/assets_light/outline-management-person-multiple-active.svg";
import FavoritedIcon from "../../../../../media/images/icons/assets_light/outline-action-favorite-fill.svg";
import BackIcon from "../../../../../media/images/icons/assets_light/outline-action-move-back-2-active.svg";
import { useState, useEffect } from "react";
import { useQuery } from '@apollo/client';
import { GET_TOTAL_FLAGGED_ITEMS } from "../../../../../graphql/GraphqlQueries";

const LeftBarFavoritedItems = ({
  searchStr,
  setSearchStr,
  type,
  user_id,
}) => {
  const OnlineUsers = useSelector((state) => state.message.online_users);
  const conv_calling_data = useSelector(
    (state) => state.message.conv_calling_data
  );



  const { id, item_type } = useParams();
  const [defaultSelect] = useState("");
  const navigate = useNavigate();
  const params = useParams();

  const handleBack = () => {
    setSearchStr("");
    navigate(-1);
  };

  const liClassIssue = (data) => {
    let classN = "";

    if (data.conversation_id === params.conversation_id) {
      classN += " selected";
    }

    if (data.system_conversation === "Everyone") {
      classN += " everyOne system_converstion";
    }

    if (data.system_conversation?.includes("team")) {
      classN += " channel system_converstion";
    }

    if (data.group === "yes") {
      classN += " private";
    } else {
      classN +=
        OnlineUsers?.includes(data.friend_id) ||
          data.conversation_id === user_id
          ? " online"
          : " offline";
    }

    if (
      Array.isArray(conv_calling_data) &&
      conv_calling_data.some(
        ({ conv_id }) => conv_id === data.conversation_id
      )
    ) {
      classN += " join_call";
    }

    if (data.close_for === "yes") {
      classN += " line_through";
    }

    if (data.has_mute?.includes(user_id)) {
      classN += " mute";
    }

    if (defaultSelect !== "ShowALL") {
      if (defaultSelect === "CreatedByMe") {
        if (data.created_by && data.created_by !== user_id) {
          classN += " display_flase";
        }
      } else if (defaultSelect === "CreatedByOthers") {
        if (data.created_by && data.created_by === user_id) {
          classN += " display_flase";
        }
      } else if (defaultSelect === "Rooms") {
        if (data.group !== "yes") {
          classN += " display_flase";
        }
      } else if (defaultSelect === "DirectMessages") {
        if (data.group === "yes") {
          classN += " display_flase";
        }
      }
    }

    return classN;
  };

  const [flaggeditems, setFlaggeditems] = useState([]);
  const [favorited_file, setFavorited_file] = useState([]);
  


  const { data: FlagCounter,loading } = useQuery(GET_TOTAL_FLAGGED_ITEMS, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (FlagCounter?.total_flagged_items?.all_start_file) {
      console.log(69, FlagCounter.total_flagged_items.all_start_file);
      setFlaggeditems(
        [...new Set(FlagCounter.total_flagged_items.all_flag_conversation)]
      );
      setFavorited_file(
        [...new Set(FlagCounter.total_flagged_items.all_start_file)]
      );
    }
  }, [FlagCounter]);

  const allUsers = useSelector((state) => state.message.conversations);
  const filteredUsers = favorited_file
    .map((id) => allUsers.find((data) => data.conversation_id === id))
    .filter((item) => item);


  const filteredVenu = filteredUsers.filter((room) =>
    room.title?.toLowerCase().includes(searchStr.toLowerCase())
  );
   // Simple skeleton component 
  const SkeletonItem = () => ( 
      <li className="conv_list !pl-[20px] animate-pulse"> 
        <div className="flex items-center justify-between !py-[10px]"> 
          <div className="flex items-center gap-[10px] w-full"> 
            <span className="w-6 h-6 bg-gray-700 rounded-full">
            </span> 
            <span className="w-32 h-4 bg-gray-700 rounded"></span> 
          </div> 
          {/* <span className="w-4 h-4 bg-gray-700 rounded-full"></span>  */}
        </div> 
        </li> 
        );

  return (
    <div className="mt-2 pt-[0px] ">
        <div className=" flex items-center hover:bg-[#243a66] border-b !border-b-[#475674] !px-[20px] !py-[10px] !mb-0 font-bold thread_back text-[#BFDCFF]"
      >        
        <div className="flex items-center gap-[5px] cursor-pointer" onClick={() => navigate(`/connect/flagged-items/${flaggeditems?.[0]}/messages`)}>
          <span className="project_icon"></span>
          <span className="font-bold text-[#BFDCFF]">Flagged items</span>
        </div>
        <span
           onClick={() => navigate(`/connect/dashboard`)}
          className="relative ml-auto right-[5px] top-[0px] w-6 h-6 bg-[#ffffff] cursor-pointer transition-colors"
          style={{
            WebkitMaskImage: `url(${BackIcon})`,
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            WebkitMaskSize: "contain",
            maskImage: `url(${BackIcon})`,
            maskRepeat: "no-repeat",
            maskPosition: "center",
            maskSize: "contain",
          }}
          />
      </div>
      <div
       
        className="flex items-center gap-[5px] !pb-[5px] !pl-[25px] hover:bg-[#243a66] py-[10px] !px-[20px] font-bold thread_back text-[#BFDCFF]"
      >
        {/* <span className="fav_icon"></span> */}
        <div className="flex items-center gap-[5px] " >
        <span
          className="relative right-[5px] top-[0px] w-5 h-5 bg-[#FFC009] transition-colors"
          style={{
            WebkitMaskImage: `url(${FavoritedIcon})`,
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            WebkitMaskSize: "contain",
            maskImage: `url(${FavoritedIcon})`,
            maskRepeat: "no-repeat",
            maskPosition: "center",
            maskSize: "contain",
          }}
        />
        <span className="font-bold text-[#BFDCFF]">Favourited files</span>
        </div>

        <span
          onClick={() => navigate(`/connect/dashboard`)}
          className="relative ml-auto right-[5px] top-[0px] w-6 h-6 bg-[#ffffff] cursor-pointer transition-colors"
          style={{
            WebkitMaskImage: `url(${BackIcon})`,
            WebkitMaskRepeat: "no-repeat",
            WebkitMaskPosition: "center",
            WebkitMaskSize: "contain",
            maskImage: `url(${BackIcon})`,
            maskRepeat: "no-repeat",
            maskPosition: "center",
            maskSize: "contain",
          }}
          />
      </div>

      <div className="group_container mt-[10px] archiveLastChild projectListTask !h-[calc(100vh-385px)] !overflow-y-auto">
        <Scrollbars
          className="custom-scrollbars"
          renderThumbVertical={({ style, ...props }) => (
            <div
              {...props}
              className="track"
              style={{
                ...style,
                backgroundColor: "#0B1F47",
                borderRadius: "50px",
              }}
            />
          )}
          autoHide={false}
        >
         {loading ? (
            // Show skeletons while loading
            <>
              <SkeletonItem />
              <SkeletonItem />
              <SkeletonItem />
               <SkeletonItem />
                <SkeletonItem />
            </>
          ) :filteredVenu.length > 0 ? (
            filteredVenu.map((v) => {
              const liClass = liClassIssue(v);

          return (
          <li key={`_room${v.id}`} className={`conv_list !pl-[20px] ${v.conversation_id === id ? "selected" : ""}`}>
            <Link to={`/connect/favorited_file/${v.conversation_id}/${item_type || 'files'}`} className="flex items-center justify-between !py-[10px] dark:!text-white">
              <div className="conv_list_icon relative">
                <div className="flex items-center gap-[10px] !w-full">
                  {v.system_conversation?.includes("team") ? (
                    <span className="channel"></span>
                  ) : v.group === "yes" ? (
                    <span className="roomGroup">
                      <img src={personsIcon} alt="room" />
                    </span>
                  ) : (
                    <span className="user">
                      <img src={personIcon} alt="user" />
                    </span>
                  )}

                  <span className="conv_list_title own">
                    {v.title} {type === "my" ? "(You)" : ""}
                  </span>
                </div>

                <div className="conv_status">
                  {liClass.includes("online") && <span className="onLine"></span>}
                  {liClass.includes("offline") && <span className="offLine"></span>}
                </div>
              </div>
            </Link>
          </li>

          );
            })
          ) : (
          <p className="no-projects-message text-[#fff] text-center pt-10">
            No room found.
          </p>
          )}
        </Scrollbars>
      </div>
    </div>
  );
};

export default LeftBarFavoritedItems;
